
import React from 'react';
import { mergeStyleSets } from '@uifabric/merge-styles';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { Link } from 'react-router-dom';

const classNames = mergeStyleSets({
    AppPageStyle: {
        margin: 0,
        padding: 0,
        background: '#e9e5da url(/client/www/theme/images/head_background_thin.png) left top repeat-x',
        width: '100vw'
    },
    AppPageStyleVerticalFill: {
        margin: 0,
        padding: 0,
        background: '#e9e5da url(/client/www/theme/images/head_background_thin.png) left top repeat-x',
        height: '100vh',
        width: '100vw'
    },
    AppHeader: {
        position: 'absolute',
        top: 0,
        float: 'left',
        width: '100%',
        height: 25,
        background: 'url(/client/www/theme/images/head_line.png) left top repeat',
        color: '#ffffff'
    },
    AppHeaderContent: {
        width: 980,
        margin: 'auto',
        a: {
            color: '#aaaaaa',
            textDecoration: 'none'
        },
        'a:hover': {
            color: '#ffffff',
            textDecoration: 'underline'
        }
    },
    AppFooter: {
        width: 980,
        margin: 'auto',
        color: '#777777',
        textAlign: 'right',
        paddingTop: 4,
        padding: 4,
    },
    Page: {
        width: 980,
        margin: 'auto'
    },
    PageHeader: {
        height: 150,
        margin: 0,
        background: 'url(/client/www/theme/images/head_image.png)',
        color: '#e9e5da'
    },
    Logo: {
        float: 'left',
        marginTop: 32,
        marginLeft: 0,
    },
    Navigation: {
        marginTop: 18,
        height: 25,
        width: '100%',
        float: 'left',
        a: {
            textDecoration: 'none',
            color: '#ffffff',
            padding: 8
        },
        'a:hover': {
            color: '#729f28',
            backgroundColor: '#fcfbfa',
            padding: 8
        },
        'a.selected': {
            color: '#729f28',
            backgroundColor: '#eeebe1',
        }
    },
    NavigationItem: {
        height: 23,
        padding: '2 10 0 10',
        fontSize: '18px',
        fontWeight: 'bold'
    },
    PageContent: {
        backgroundColor: '#eeebe1'
    }
});

const AppFooter = () => {
    const version = process.env.REACT_APP_VERSION || 'vDev';
    return (
        <div className={classNames.AppFooter}>
            <div>© HF Biz s.r.o. | Myslivecký portál - {version}</div>
        </div>
    );
}

const AppHeader = ({content}) => {
    return (
        <div className={classNames.AppHeader}>
            <div className={classNames.AppHeaderContent}>
                {content}
            </div>
        </div>
    )
}

const Page = ({children, isAppMp, navigationItems, page}) => {
    return (
        <Stack verticalFill className={classNames.Page}>
            <PageHeader
                isAppMp={isAppMp}
                navigationItems={navigationItems}
                page={page}
            />
            <Stack.Item grow>
                <PageContent>
                    {children}
                </PageContent>
            </Stack.Item>
        </Stack>
    );
}

const PageHeader = ({isAppMp, navigationItems, page}) => {
    const title = (isAppMp === true)
        ? 'Aplikace Mysliveckého portálu'
        : 'Myslivecký portál'
    return (
        <div className={classNames.PageHeader}>
            <div className={classNames.Logo}>
                <h1>{title}</h1>
            </div>
            <Navigation
                navigationItems={navigationItems}
                page={page}
            />
        </div>
    )
}

const PageContent = ({children}) => {
    return (
        <Stack verticalFill className={classNames.PageContent}>
            {children}
        </Stack>
    );
}

const Navigation = ({navigationItems, page}) => {
    return (
        <Stack horizontal tokens={{childrenGap: 16}} className={classNames.Navigation}>
            {navigationItems.map(item => {
                let link = '';
                let grow = 1;
                if (item.to) {
                    grow = 0;
                    link = (
                        <Link
                            key={item.page}
                            to={item.to}
                            className={`${classNames.NavigationItem} ${page === item.page ? 'selected' : ''}`}
                        >
                            {item.title}
                        </Link>
                    );
                }
                if (item.href) {
                    grow = 0;
                    link = (
                        <a href={item.href} className={classNames.NavigationItem}>{item.title}</a>
                    );
                }
                return <Stack.Item grow={grow} key={item.page}>{link}</Stack.Item>
            })}
        </Stack>
    );
}

const AppPageStyle = ({
    appHeaderContent,
    children,
    isAppMp,
    navigationItems,
    page,
    verticalFill
}) => {

    const className = verticalFill ? classNames.AppPageStyleVerticalFill : classNames.AppPageStyle;
    return (
        <Stack className={className}>
            <AppHeader
                content={appHeaderContent}
            />
            <Stack.Item grow>
                <Page isAppMp={isAppMp} navigationItems={navigationItems} page={page}>
                    {children}
                </Page>
            </Stack.Item>
            <AppFooter />
        </Stack>
    );
};

export default AppPageStyle;
